export const CREATE_CATEGORY_TYPE = 'create_category_type';
export const EDIT_CATEGORY_TYPE = 'edit_category_type';
export const DELETE_CATEGORY_TYPE = 'delete_category_type';

export const CREATE_TUTORIAL_TYPE = 'create_tutorial_type';
export const EDIT_TUTORIAL_TYPE = 'edit_tutorial_type';
export const DELETE_TUTORIAL_TYPE = 'delete_tutorial_type';


export const CATEGORY_CONSTRAINS = {
  title: {
    presence: { message: ' is required' }
  }
};

export const TARGET_FILE_MAX_SIZE = 5 * 1024 * 1024;
export const PROVIDER_LOGO_CONTENT_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];


export const TUTORIAL_CONSTRAINS = {
  title: {
    presence: {message: ' Title is required'},
    length: {
      maximum: 50,
      tooLong: 'Only 50 symbols allowed'
    }
  },
  description: {
    length: {
      maximum: 100,
      tooLong: 'Only 100 symbols allowed for description'
    }
  },
  video_url: {
    url: { message: 'Looks like invalid url' }
  }
};

export const TOPIC_CONSTRAINS = (object) => {
  const constrains = {
    title: {
      presence: {message: ' Title is required'},
      length: {
        maximum: 50,
        tooLong: 'Only 50 symbols allowed'
      }
    },
    description: {
      presence: {message: 'Description is required'},
    },
    tutorial_type: {
      presence: {message: 'Select type'},
    },
    reimbursement_type: {
      ...object.is_visible_quize ? {
        presence: {message: 'Select type'},
      } : {},
    },
    // icgp_number: {
    //   presence: {message: 'ICGP is required'},
    // },
    // cpd_points: {
    //   presence: {message: 'CPD points is required'},
    // }
  }
  return constrains;
};

export const QUESTION_CONSTRAINS = {
  end_time: {
    presence: { message: 'Empty' },
    numericality: {
        greaterThan: 0,
        notGreaterThan: 'Empty',
        notValid: 'Empty'
    }
  },
  title: {
    presence: { message: 'Title is required'}
  }
};

export const CPD_QUIZ_CONSTRAINS = {
  question: {
    presence: { message: 'Question is required' }
  },
  correct: {
    presence: { message: 'Correct is required' }
  }
};

export const RESOURCE_CONSTRAINS = {
  title: {
    presence: { message: 'Title is required' },
  },
  // file: {
  //   presence: { message: 'File is required' },
  // },
  resourse_type: {
    presence: { message: 'Resource type is required' },
  },
};



// WEBPACK FOOTER //
// ./src/constants/adminPupups.js